export default {
  receiverSettings: []
}
